import { classNamePrefix as prefixCt } from "@/utils/common";
import "./index.less";

export default class linkRender {
  fragmentCls: string;

  config: Record<string, any>;

  constructor(config = {}) {
    this.fragmentCls = `.${prefixCt("link")}`;
    this.config = config;
  }

  containerRender = ($container) => {
    const nodes = $container.querySelectorAll("a");

    nodes.forEach((node) => {
      const href = node.getAttribute("href");
      if (!href) return;

      if (this.config.openInNewTab) {
        node.setAttribute("target", "_blank");
      }

      const autoUpdate = node.getAttribute("data-auto_update") === "1";

      if (autoUpdate && this.config.provider?.getLinkTitle) {
        this.config.provider
          .getLinkTitle(node.getAttribute("href"))
          .then((title) => {
            node.classList.add("ct-link-auto-update");
            node.innerText = title;
          })
          .catch((e) => {
            console.error(e);
          });
      }
    });
  };
}
